import { PropsWithChildren } from 'react'

interface InputErrorProps extends PropsWithChildren {
  extraClassName?: string
}

export default function InputError({
  children,
  extraClassName,
}: InputErrorProps) {
  return (
    children &&
    children !== '' && (
      <p
        aria-invalid="true"
        className={`type-body-8 text-error my-2 text-wrap ${extraClassName}`}
      >
        {children}
      </p>
    )
  )
}
